import { WidgetRepository } from '@framework/engine';
import { CandidateWidgetType } from './widgets/candidate/CandidateWidget.type';
import { ElectoralListChooserWidgetType } from './widgets/electoral-list-chooser/ElectoralListChooserWidget.type';
import { MultiPreferenceWidgetType } from './widgets/multi-preference/MultiPreferenceWidget.type';
import { SiapDataWidgetType } from './widgets/siap-data/SiapDataWidget.type';
import { VoteWidgetType } from './widgets/vote/VoteWidget.type';

export function initThemeWidgetRepository() {
  console.log('@framework/theme-mic: initThemeWidgetRepository');

  /**
   * Widget per la visualizzazione dei dati SIAP
   */
  WidgetRepository.register(SiapDataWidgetType);

  /**
   * Widget per la selezione di più preferenze
   */
  WidgetRepository.register(MultiPreferenceWidgetType);

  /**
   * Widget per la selezione Candidato
   */
  WidgetRepository.register(CandidateWidgetType);

  /**
   * Widget di voto
   */
  WidgetRepository.register(VoteWidgetType);

  /**
   * Widget di scelta lista elettorale (lista + candidato), per le votazioni CS.
   * Il voto viene inviato dal pulsante di voto (VoteWidget).
   */
  WidgetRepository.register(ElectoralListChooserWidgetType);
}
